import { defineStore } from 'pinia'

export default defineStore({
    id: 'error',
    state: () => ({
        errorType: 'default'
    }),
    getters: {
        getErrorType: (state) => state.errorType
    },
    actions: {
        setErrorType(errorType) {
            this.errorType = errorType
        }
    }
})
